import { useMemo } from 'react';

import { convertTimeLetter, formatTimeEvent } from '@helpers';
import type { DashboardOverallResponse } from '@api/domain/types';

export interface UseManageDashboardSummaryParams {
  overall: DashboardOverallResponse | null;
}

const formatValue = (seconds: number) => formatTimeEvent(convertTimeLetter(Math.abs(seconds)), false, false).trim();

export const useManageDashboardSummary = ({ overall }: UseManageDashboardSummaryParams) => {
  return useMemo(() => {
    const lossSeconds = Math.abs(overall?.negativeScopeTotalTimeTotalInSeconds ?? 0);
    const gainSeconds = overall?.positiveScopeTotalTimeTotalInSeconds ?? 0;
    const netSeconds = overall?.scopeTotalTimeTotalInSeconds ?? 0;
    const netNegative = netSeconds < 0;

    return {
      lossText: formatValue(lossSeconds),
      gainText: formatValue(gainSeconds),
      netText: (netNegative ? '-' : '') + formatValue(netSeconds),
      netColorKey: netNegative ? 'System/Light/Red' : 'System/Light/Green',
    };
  }, [overall]);
};
